module.exports = __webpack_public_path__ + "static/media/083-no video.acc9e926.svg";